module.exports = __webpack_public_path__ + "static/media/custom.141d80f2.svg";